import get from 'lodash.get';
import { toast } from 'react-toastify';

export const responseData = (res, key = '') => get(res, key);

export const responseErrors = res => get(res, 'data.errors');

export const toastResponseErrors = (response = {}, key) => {
  if (typeof response === 'string') {
    toast.error(String(response));
  }

  const { data, message } = response;

  const errors = key ? get(data, `errors.${key}`) : get(data, 'errors');

  if (errors) {
    if (Array.isArray(errors)) return toast.error(errors.join(''));
    return toast.error(String(errors));
  }

  if (message) {
    toast.error(String(message));
  }

  if (data) {
    return toast.error(String(data));
  }
};



// WEBPACK FOOTER //
// ./src/utils/response.js